declare global {
  interface Window {
    dataLayer: unknown[];
    __thirdPartyScheduled?: boolean;
    __thirdPartyLoaded?: boolean;
  }
}

const DEFAULT_GTM_ID = "GTM-P9D9J92M";
const DEFAULT_HUBSPOT_PORTAL_ID = "145466031";

function loadScriptOnce(id: string, src: string, async = true): void {
  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  script.async = async;
  document.head.appendChild(script);
}

function loadGtm(): void {
  const gtmId = import.meta.env.VITE_GTM_ID || DEFAULT_GTM_ID;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  loadScriptOnce("gtm-loader", `https://www.googletagmanager.com/gtm.js?id=${gtmId}`);
}

function loadHubSpot(): void {
  const hubspotPortalId = import.meta.env.VITE_HUBSPOT_PORTAL_ID || DEFAULT_HUBSPOT_PORTAL_ID;
  loadScriptOnce(
    "hs-script-loader",
    `https://js-eu1.hs-scripts.com/${hubspotPortalId}.js`,
  );
}

function startThirdPartyScripts(): void {
  if (window.__thirdPartyLoaded) {
    return;
  }

  window.__thirdPartyLoaded = true;
  loadGtm();
  loadHubSpot();
}

export function scheduleThirdPartyLoad(): void {
  if (typeof window === "undefined" || window.__thirdPartyScheduled) {
    return;
  }

  window.__thirdPartyScheduled = true;

  const onUserInteraction = () => {
    removeListeners();
    startThirdPartyScripts();
  };

  const events: Array<keyof WindowEventMap> = [
    "pointerdown",
    "keydown",
    "scroll",
    "touchstart",
  ];

  const removeListeners = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, onUserInteraction);
    });
  };

  events.forEach((eventName) => {
    window.addEventListener(eventName, onUserInteraction, {
      once: true,
      passive: true,
    });
  });

  const idleDelayMs = Number(import.meta.env.VITE_THIRD_PARTY_IDLE_DELAY_MS || 0);
  if (idleDelayMs <= 0) {
    return;
  }

  window.setTimeout(() => {
    removeListeners();
    startThirdPartyScripts();
  }, idleDelayMs);
}
